import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9aae19a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-pdf-viewer" }
const _hoisted_2 = {
  key: 0,
  class: "hd-pdf-viewer__controls"
}
const _hoisted_3 = { class: "hd-pdf-viewer__page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf = _resolveComponent("pdf")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_pdf, {
      class: "hd-pdf-viewer__pdf",
      src: _ctx.source,
      page: _ctx.currentPage,
      annotation: true,
      scale: _ctx.scale,
      "pdf-width": _ctx.pdfWidth,
      "pdf-height": _ctx.pdfHeight,
      onNumPages: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pageCount = $event)),
      onLinkClicked: _ctx.evaluateLink,
      onLoading: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loading = $event))
    }, null, 8, ["src", "page", "scale", "pdf-width", "pdf-height", "onLinkClicked"]),
    (_ctx.controls && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "hd-pdf-viewer__go-back",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goBack()))
          }, [
            (_ctx.goBackIcon !== '')
              ? (_openBlock(), _createBlock(_component_base_image_svg, {
                  key: 0,
                  class: "hd-pdf-viewer__control-icon",
                  source: _ctx.goBackIcon
                }, null, 8, ["source"]))
              : _createCommentVNode("", true),
            _createVNode(_component_lyra_asset, { "asset-key": "pdf-viewer-go-back-text" })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["hd-pdf-viewer__control hd-pdf-viewer__control--left", { 'is-inactive': !_ctx.hasPreviousPage }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo(-1)))
          }, [
            _createVNode(_component_base_image_svg, {
              class: "hd-pdf-viewer__control-icon",
              source: require('!html-loader!@/ui/assets/icons/chevron-left.svg')
            }, null, 8, ["source"])
          ], 2),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.currentPage) + " of " + _toDisplayString(_ctx.pageCount), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["hd-pdf-viewer__control hd-pdf-viewer__control--right", { 'is-inactive': !_ctx.hasNextPage }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goTo(1)))
          }, [
            _createVNode(_component_base_image_svg, {
              class: "hd-pdf-viewer__control-icon",
              source: require('!html-loader!@/ui/assets/icons/chevron-right.svg')
            }, null, 8, ["source"])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}